module.exports = __webpack_public_path__ + "img/stt-edit.699af976.png";